<script setup lang="ts">
const reservationStore = useReservationStore()
const { 
  voucher,
  manufacturers,
  contractors
} = storeToRefs(reservationStore)
useHead({
  titleTemplate: 'Formularz rezerwacji - %s',
  meta: [
    { name: 'robots', content: 'index,follow' }
  ]
})
onUnmounted(() => {
  reservationStore.reset()
})
</script>

<template>
  <div class="container mx-auto">
    <Breadcrumbs :breadcrumbs="[{ name: 'Zrealizuj voucher' }]" />
    <VoucherCreateRegistrationByHash v-if="voucher" :voucher="voucher" :manufacturers="manufacturers" :contractors="contractors" />
    <VoucherGetVoucherByHash v-else />
  </div>
</template>
